module.exports = __webpack_public_path__ + "static/Counselors-List-Kannada-a54606746e65d3c073dd29ae56096be2.pdf";